module.exports = __webpack_public_path__ + "Server-Healthy.AzureWebApp.735ccede618abf1f4689de7c6cf90b76.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/machines/Server-Healthy.AzureWebApp.png
// module id = 8829700513310684
// module chunks = 1